import Service, { inject as service } from '@ember/service';
import config from 'garaje/config/environment';
import getCompany from 'garaje/utils/graphql/getCompany';
import type { GetCompanyQuery, GetCompanyQueryVariables } from 'garaje/utils/graphql/graphql-types';

import type ApolloService from './apollo-extension';

export default class RoombaGraphqlService extends Service {
  @service declare apolloExtension: ApolloService;
  @service declare state: Service;

  async getCompany(): Promise<GetCompanyQuery['company']> {
    try {
      return await this.apolloExtension.watchQuery<GetCompanyQuery, GetCompanyQueryVariables, 'company'>(
        {
          query: getCompany,
          context: {
            uri: `${config.apiHost}/a/graphql_federated`,
          },
        },
        'company'
      );
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql getCompany query. Error: ', JSON.stringify(e));
      throw e;
    }
  }
}
